let loginUrl = '';
let creditsUrl = '';
let otherUrl = '';
let webTrackUrl = '';
let webTrackUrlForDomainUpdate = '';
let QualifyUrl = '';
let AdminConfigUrl = '';
let TransformUrl = '';
let ExtractUrl = '';
let ExtractUrlV2 = '';
let ExtractUrlV3 = '';
let SyncUrl = '';
let mdqs = '';
let paula = '';
let importUrl = '';
let contactsInsertUpdateUrl = '';
let mlUrl = '';
let sproutsAgentEndPoint = '';
let ruleDefinition = '';
let ruleDefinitionV1 = '';
let ruleExecutorService = '';
let aiNativeUrl = '';
let notificationsBaseUrl = '';
// API Key Management Service — the gateway's API registry and per-customer rate limits.
let akmsBaseUrl = '';
// API Gateway — where customers actually send their requests. Shown on the API Keys and API
// Configuration screens so an endpoint path can be read as a whole URL. Not used for any call the
// app makes itself; the app reaches AKMS directly.
let gatewayBaseUrl = '';
let logoBaseUrl = '';
if (process.env.REACT_APP_DEV_ENV === 'prod') {
  mdqs = 'https://mdqs.sprouts.ai';
  loginUrl = 'https://abm.sprouts.ai/login';
  creditsUrl = 'https://prodms.sprouts.ai/cms';
  otherUrl = 'https://prodms.sprouts.ai/ui';
  webTrackUrl = 'https://prodms.sprouts.ai/ipls';
  webTrackUrlForDomainUpdate = 'https://prodms.sprouts.ai/ipls';
  AdminConfigUrl = 'https://prodms.sprouts.ai/admin-features';
  QualifyUrl = 'https://prodms.sprouts.ai/rule';
  TransformUrl = 'https://prodms.sprouts.ai/transform';
  ExtractUrl = 'https://prodms.sprouts.ai/extract';
  ExtractUrlV2 = 'https://prodms.sprouts.ai/unifiedhub';
  ExtractUrlV3 = 'https://prodms.sprouts.ai/anyconnector';
  SyncUrl = 'https://prodms.sprouts.ai/jos';
  paula = 'https://ml.sprouts.ai/chat';
  importUrl = 'https://prodms.sprouts.ai/upload';
  contactsInsertUpdateUrl = 'https://prodms.sprouts.ai/upload';
  mlUrl = 'https://ml.sprouts.ai';
  sproutsAgentEndPoint = 'https://agenticprodapi.sprouts.ai/threads';
  ruleDefinition = 'https://newrdef.sprouts.ai';
  ruleDefinitionV1 = 'https://newrdef.sprouts.ai';
  ruleExecutorService = 'https://ruleexec.sprouts.ai';
  aiNativeUrl = 'https://gtm.sprouts.ai';
  notificationsBaseUrl = 'https://prodms.sprouts.ai/nmos';
  logoBaseUrl = 'https://logo.sprouts.ai/logo';
  akmsBaseUrl = 'https://prodms.sprouts.ai/akms';
  gatewayBaseUrl = 'https://prodms.sprouts.ai/apigateway';
} else if (process.env.REACT_APP_DEV_ENV === 'dev') {
  mdqs = 'https://devmdqs.sprouts.ai';
  loginUrl = 'https://devms.sprouts.ai:5001';
  creditsUrl = 'https://devms.sprouts.ai:8070';
  otherUrl = 'https://devms.sprouts.ai:6001';
  webTrackUrl = 'https://qams.sprouts.ai/ipls';
  webTrackUrlForDomainUpdate = 'https://qams.sprouts.ai/ipls';
  QualifyUrl = 'https://devms.sprouts.ai:9090';
  AdminConfigUrl = 'https://devms.sprouts.ai:9060';
  TransformUrl = 'https://devms.sprouts.ai:6575';
  ExtractUrl = 'https://devms.sprouts.ai:6171';
  ExtractUrlV2 = 'https://devms.sprouts.ai:6179';
  ExtractUrlV3 = 'https://devms.sprouts.ai:6178';
  SyncUrl = 'https://devms.sprouts.ai:7171';
  paula = 'https://qaml.sprouts.ai/chat';
  importUrl = 'https://devms.sprouts.ai:6001';
  contactsInsertUpdateUrl = 'https://devms.sprouts.ai:6001';
  mlUrl = 'https://devml.sprouts.ai';
  sproutsAgentEndPoint = 'https://agenticapi.sprouts.ai/threads';
  ruleDefinition = 'https://qardef.gtmsprouts.ai';
  ruleDefinitionV1 = 'https://qardef.gtmsprouts.ai';
  // ruleDefinition = 'http://localhost:3001';
  ruleExecutorService = 'https://qaexec.gtmsprouts.ai';
  aiNativeUrl = 'https://ui.gtmsprouts.ai';
  notificationsBaseUrl = 'https://qams.sprouts.ai/nmos';
  logoBaseUrl = 'https://logo.sprouts.ai/logo';
  akmsBaseUrl = 'https://qams.sprouts.ai/akms';
  gatewayBaseUrl = 'https://qams.sprouts.ai/apigateway';
} else if (process.env.REACT_APP_DEV_ENV === 'qa') {
  mdqs = 'https://qamdqs.sprouts.ai';
  loginUrl = 'https://qams.sprouts.ai/login';
  creditsUrl = 'https://qams.sprouts.ai/cms';
  otherUrl = 'https://qams.sprouts.ai/ui';
  webTrackUrl = 'https://qams.sprouts.ai/ipls';
  webTrackUrlForDomainUpdate = 'https://qams.sprouts.ai/ipls';
  QualifyUrl = 'https://qams.sprouts.ai/rule';
  AdminConfigUrl = 'https://qams.sprouts.ai/admin-features';
  TransformUrl = 'https://qams.sprouts.ai/transform';
  ExtractUrl = 'https://qams.sprouts.ai/extract';
  ExtractUrlV2 = 'https://qams.sprouts.ai/unifiedhub';
  ExtractUrlV3 = 'https://qams.sprouts.ai/anyconnector';
  SyncUrl = 'https://qams.sprouts.ai/jos';
  paula = 'https://qaml.sprouts.ai/chat';
  importUrl = 'https://qams.sprouts.ai/ui';
  contactsInsertUpdateUrl = 'https://qams.sprouts.ai/ui';
  mlUrl = 'https://qaml.sprouts.ai';
  sproutsAgentEndPoint = 'https://agenticapi.sprouts.ai/threads';
  // Use localhost for local development
  // ruleDefinition = 'http://localhost:3003';
  // ruleDefinitionV1 = 'http://localhost:3003';
  // ruleExecutorService = 'http://localhost:3005';
  ruleDefinition = 'https://qardef.gtmsprouts.ai';
  ruleDefinitionV1 = 'https://qardef.gtmsprouts.ai';
  ruleExecutorService = 'https://qaexec.gtmsprouts.ai';
  aiNativeUrl = 'https://ui.gtmsprouts.ai';
  notificationsBaseUrl = 'https://qams.sprouts.ai/nmos';
  logoBaseUrl = 'https://logo.sprouts.ai/logo';
  akmsBaseUrl = 'https://qams.sprouts.ai/akms';
  gatewayBaseUrl = 'https://qams.sprouts.ai/apigateway';
} else if (process.env.REACT_APP_DEV_ENV === 'demo') {
  mdqs = 'https://devmdqs.sprouts.ai';
  loginUrl = 'https://demoms.sprouts.ai:5000';
  creditsUrl = 'https://demoms.sprouts.ai:8070';
  otherUrl = 'https://demoms.sprouts.ai:6060';
  webTrackUrl = 'https://qams.sprouts.ai:6000';
  webTrackUrlForDomainUpdate = 'https://qams.sprouts.ai:6000';
  QualifyUrl = 'https://qams.sprouts.ai:9090';
  AdminConfigUrl = 'https://qams.sprouts.ai:9060';
  TransformUrl = 'https://qams.sprouts.ai:6575';
  ExtractUrl = 'https://qams.sprouts.ai:6171';
  SyncUrl = 'https://qams.sprouts.ai:7171';
  paula = 'https://qaml.sprouts.ai/chat';
  importUrl = 'https://demoms.sprouts.ai:6060';
  contactsInsertUpdateUrl = 'https://demoms.sprouts.ai:6060';
  mlUrl = 'https://devml.sprouts.ai';
  sproutsAgentEndPoint = 'https://agenticapi.sprouts.ai/threads';
  ruleExecutorService = 'https://demoexec.sprouts.ai';
  aiNativeUrl = 'https://app.gtmsprouts.ai';
  logoBaseUrl = 'https://logo.sprouts.ai/logo';
  akmsBaseUrl = 'https://qams.sprouts.ai/akms';
  gatewayBaseUrl = 'https://qams.sprouts.ai/apigateway';
} else {
  loginUrl = 'https://devms.sprouts.ai:5001';
  creditsUrl = 'https://devms.sprouts.ai:8070';
  otherUrl = 'https://devms.sprouts.ai:6001';
  webTrackUrl = 'https://qams.sprouts.ai/ipls';
  paula = 'https://qaml.sprouts.ai/chat';
  importUrl = 'https://devms.sprouts.ai:6001';
  contactsInsertUpdateUrl = 'https://devms.sprouts.ai:6001';
  mlUrl = 'https://devml.sprouts.ai/';
  sproutsAgentEndPoint = 'https://agenticapi.sprouts.ai/threads';
  ruleExecutorService = 'https://devexec.gtmsprouts.ai';
  aiNativeUrl = 'https://ui.gtmsprouts.ai';
  notificationsBaseUrl = 'https://qams.sprouts.ai/nmos';
  logoBaseUrl = 'https://logo.sprouts.ai/logo';
  akmsBaseUrl = 'https://qams.sprouts.ai/akms';
  gatewayBaseUrl = 'https://qams.sprouts.ai/apigateway';
}
export const BASE_API_URL = loginUrl;
export const CREDITS_BASE_URL = creditsUrl;
export const REACT_APP_BASE_API_FILTER_URL = otherUrl;
export const WEB_TRACK_URL = webTrackUrl;
export const WEB_TRACK_URL_FOR_DOMAIN_UPDATE = webTrackUrlForDomainUpdate;
export const QUALIFY_URL = QualifyUrl;
export const ADMIN_CONFIG_URL = AdminConfigUrl;
export const TRANSFORM_URL = TransformUrl;
export const EXTRACT_URL = ExtractUrl;
export const EXTRACT_URL_V2 = ExtractUrlV2;
export const EXTRACT_URL_V3 = ExtractUrlV3;
export const SYNC_URL = SyncUrl;
export const MDQS_BASEURL = mdqs;
export const CHROME_EXTENSION_ID = process.env.REACT_APP_CHROME_EXTENSION_ID;
export const BLUEBERRY_EXTENSION_ID = process.env.REACT_APP_BLUEBERRY_EXTENSION_ID;
export const UPDATE_ZAPIER_KEYS_URL = 'https://demoms.sprouts.ai:6060';
export const PAULA_BOT_URL = paula;
export const IMPORT_URL = importUrl;
export const CONTACT_INSERT_UPDATE_URL = contactsInsertUpdateUrl;
export const HPM_CONFIG_BASE_URL = importUrl;
// export const REACT_APP_BASE_API_GET_FILE_HEADER = 'https://ms.sprouts.ai:6060';
export const ML_BASE_URL = mlUrl;
export const SPROUTS_AGENT_BASE_ENDPOINT = sproutsAgentEndPoint;
export const RULE_DEFINITION_URL = ruleDefinition;
export const RULE_DEFINITION_URL_V1 = ruleDefinitionV1;
export const RULE_EXECUTOR_SERVICE_URL = ruleExecutorService;
export const AI_NATIVE_URL = aiNativeUrl;
export const NOTIFICATIONS_BASE_URL = notificationsBaseUrl;
/**
 * AKMS and the gateway, overridable for local development.
 *
 * <p>Every branch above points at a deployed environment, which is right for a normal run but wrong
 * while AKMS itself is being changed: the tier endpoints do not exist on QA until the service is
 * deployed there, so a local UI pointed at QA gets a 404 from screens that are working perfectly.
 *
 * <p>Set REACT_APP_AKMS_BASE_URL in .env.local to point at a locally running AKMS — the same
 * pattern REACT_APP_CREDIT_MS_URL already uses. Unset, this is inert and the per-environment value
 * above applies, so nothing deployed can be affected by it.
 */
export const AKMS_BASE_URL = process.env.REACT_APP_AKMS_BASE_URL || akmsBaseUrl;
export const GATEWAY_BASE_URL = process.env.REACT_APP_GATEWAY_BASE_URL || gatewayBaseUrl;
export const LOGO_BASE_URL = logoBaseUrl;
